"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEATH_SCATTER_FAR_LANDING_MAX_TICKS = exports.DEATH_SCATTER_FAR_LANDING_MIN_TICKS = exports.DEATH_SCATTER_MID_LANDING_MAX_TICKS = exports.DEATH_SCATTER_MID_LANDING_MIN_TICKS = exports.DEATH_SCATTER_NEAR_LANDING_MAX_TICKS = exports.DEATH_SCATTER_NEAR_LANDING_MIN_TICKS = exports.DeathScatterBandV4 = exports.DEATH_SCATTER_FAR_RADIUS_CLAMP = exports.DEATH_SCATTER_PUDDLE_CHUNK_MAX_VALUE = exports.DEATH_SCATTER_PUDDLE_RADIUS_MAX = exports.DEATH_SCATTER_PUDDLE_RADIUS_MIN = exports.DEATH_SCATTER_FAR_VALUE_SHARE = exports.DEATH_SCATTER_MID_VALUE_SHARE = exports.DEATH_SCATTER_NEAR_VALUE_SHARE = exports.DEATH_SCATTER_SINGLE_SPARK_THRESHOLD = exports.DEATH_SCATTER_CLIENT_MAX_ACTIVE_SHARDS = exports.DEATH_SCATTER_MAX_BUNDLES = exports.DEATH_SCATTER_CLIENT_FX_ENABLED = exports.DEATH_SCATTER_ENABLED = void 0;
exports.deathScatterBundleCountFromValue = deathScatterBundleCountFromValue;
exports.deathScatterRadiusScaleFromValue = deathScatterRadiusScaleFromValue;
exports.deathScatterRadiusRangeForBand = deathScatterRadiusRangeForBand;
const constants_1 = require("./constants");
const snake_growth_1 = require("./snake-growth");
exports.DEATH_SCATTER_ENABLED = true;
exports.DEATH_SCATTER_CLIENT_FX_ENABLED = true;
exports.DEATH_SCATTER_MAX_BUNDLES = 96;
exports.DEATH_SCATTER_CLIENT_MAX_ACTIVE_SHARDS = 64;
exports.DEATH_SCATTER_SINGLE_SPARK_THRESHOLD = 100;
exports.DEATH_SCATTER_NEAR_VALUE_SHARE = 0.60;
exports.DEATH_SCATTER_MID_VALUE_SHARE = 0.25;
exports.DEATH_SCATTER_FAR_VALUE_SHARE = 0.15;
exports.DEATH_SCATTER_PUDDLE_RADIUS_MIN = 80;
exports.DEATH_SCATTER_PUDDLE_RADIUS_MAX = 140;
exports.DEATH_SCATTER_PUDDLE_CHUNK_MAX_VALUE = Math.min(3, snake_growth_1.MAX_MERGED_SPARK_VALUE);
exports.DEATH_SCATTER_FAR_RADIUS_CLAMP = 5000;
exports.DeathScatterBandV4 = {
    NEAR: 0,
    MID: 1,
    FAR: 2,
};
function msToTicks(ms) {
    return Math.max(1, Math.round(ms / (1000 / constants_1.TICK_RATE)));
}
exports.DEATH_SCATTER_NEAR_LANDING_MIN_TICKS = msToTicks(600);
exports.DEATH_SCATTER_NEAR_LANDING_MAX_TICKS = msToTicks(860);
exports.DEATH_SCATTER_MID_LANDING_MIN_TICKS = msToTicks(860);
exports.DEATH_SCATTER_MID_LANDING_MAX_TICKS = msToTicks(1220);
exports.DEATH_SCATTER_FAR_LANDING_MIN_TICKS = msToTicks(1220);
exports.DEATH_SCATTER_FAR_LANDING_MAX_TICKS = msToTicks(1620);
function deathScatterBundleCountFromValue(sparksDropped) {
    const total = Math.max(0, Math.floor(sparksDropped));
    if (total <= 0)
        return 0;
    if (total <= exports.DEATH_SCATTER_SINGLE_SPARK_THRESHOLD)
        return total;
    const overflow = total - exports.DEATH_SCATTER_SINGLE_SPARK_THRESHOLD;
    return Math.max(64, Math.min(exports.DEATH_SCATTER_MAX_BUNDLES, Math.round(64 + Math.sqrt(overflow) * 4)));
}
function deathScatterRadiusScaleFromValue(sparksDropped) {
    return Math.max(0, Math.min(1, Math.sqrt(Math.max(0, sparksDropped) / 1000)));
}
function deathScatterRadiusRangeForBand(sparksDropped, band) {
    const scale = deathScatterRadiusScaleFromValue(sparksDropped);
    if (band === exports.DeathScatterBandV4.NEAR) {
        return {
            min: 0,
            max: 80 + 820 * scale,
        };
    }
    if (band === exports.DeathScatterBandV4.MID) {
        return {
            min: 320 + 180 * scale,
            max: 420 + 2480 * scale,
        };
    }
    return {
        min: 700 + 420 * scale,
        max: Math.min(exports.DEATH_SCATTER_FAR_RADIUS_CLAMP, 650 + 4350 * scale),
    };
}
//# sourceMappingURL=death-scatter.js.map